import { formatPrice } from "../utils/format-price";

type DiscountedPriceProps = {
  /** Unit catalog price, in cents. */
  catalogCents: number;
  /** Unit price actually paid, in cents. */
  paidCents: number;
  currency: string;
  quantity?: number;
};

/** Paid price, preceded by the struck catalog price when the two differ. */
export function DiscountedPrice({
  catalogCents,
  paidCents,
  currency,
  quantity = 1,
}: DiscountedPriceProps) {
  return (
    <>
      {catalogCents !== paidCents && (
        <span className="line-through">
          {formatPrice(catalogCents * quantity, currency)}{" "}
        </span>
      )}
      {formatPrice(paidCents * quantity, currency)}
    </>
  );
}
